import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { showFlyout } from '../../../Dashboard/actions';
import { getFlyout } from '../../../Dashboard/selectors';
import { useAction } from '../../../Common/hooks';
import { upDirection, downDirection } from '../../../Common/constants';
import { setGridSortCriteria, setCurrentSelectedAgencyId } from '../../actions';
import { agenciesFlyout } from '../../constants';
import {
  getAgenciesGridSortCriteria,
  selectAgenciesList,
  selectAgenciesListIsLoading,
} from '../../selectors';

const useAgenciesList = () => {
  const [activeRow, setActiveRow] = useState(undefined);
  const [agenciesReports, setAgenciesReports] = useState([]);
  const flyout = useSelector(getFlyout);
  const { sortByColumn, sortDirection } = useSelector(getAgenciesGridSortCriteria);
  const dispatchGridSortCriteria = useAction(setGridSortCriteria);
  const dispatchShowFlyout = useAction(showFlyout);
  const dispatchSelectedAgencyId = useAction(setCurrentSelectedAgencyId);
  const list = useSelector(selectAgenciesList);
  const isLoading = useSelector(selectAgenciesListIsLoading);

  useEffect(() => {
    setAgenciesReports(list);
  }, [list]);

  useEffect(() => {
    if (flyout.show === false) {
      setActiveRow(null);
    }
  }, [flyout]);

  const sortRows = () => {
    const rowsCopy = [...agenciesReports];

    if (sortDirection === 'up') {
      rowsCopy.sort((a, b) => {
        if (a[sortByColumn] < b[sortByColumn]) {
          return -1;
        }

        if (a[sortByColumn] > b[sortByColumn]) {
          return 1;
        }

        return 0;
      });
    } else {
      rowsCopy.sort((a, b) => {
        if (a[sortByColumn] < b[sortByColumn]) {
          return 1;
        }

        if (a[sortByColumn] > b[sortByColumn]) {
          return -1;
        }

        return 0;
      });
    }

    setAgenciesReports(rowsCopy);
  };

  useEffect(() => {
    sortRows();
  }, [sortDirection]);

  const handleRowClick = ({ agencyId }) => {
    setActiveRow(undefined);
    dispatchSelectedAgencyId(agencyId);
    dispatchShowFlyout(agenciesFlyout);
  };

  const handleColumnClick = ({ headerName, direction }) => {
    sortRows();
    dispatchGridSortCriteria({
      sortByColumn: headerName,
      sortDirection: direction === upDirection ? downDirection : upDirection,
    });
  };

  return {
    handleColumnClick,
    sortByColumn,
    sortDirection,
    handleRowClick,
    activeRow,
    agenciesReports,
    isLoading,
  };
};

export default useAgenciesList;
